import React,{useRef, useState, useEffect} from "react";
import { Select, Form, Col, Row, Button } from "react-bootstrap";
import EditableRangeFormatable from "../components/EditableRangeFormatable";
import atlasApi from "../utils/atlasapi";
import { X, Trash} from "@phosphor-icons/react";
import ColorPicker from "../components/ColorPicker";
import LayerExclusion		from "../classes/LayerExclusion";
import {formatDistance, parseMeters} from "../utils/functions";


class ExclusionPanel extends React.Component {

	
	constructor(props) {
		super(props);
		
		
		
		this.range = React.createRef();
		
		this.open = this.props.setup.open;
		this.handler = this.props.handler;
		this.clickedId = -1;
		this.idx = 0;
		this.defaultColor = LayerExclusion.defaultColor;
		this.defaultRadius = LayerExclusion.defaultRadius;
		this.state = {
			
		};
		
	}
	componentDidMount = ()=>{
		if(this.handler)
			this.Type = this.handler.type.charAt(0).toUpperCase() + this.handler.type.slice(1);
	}

	async handleChange(e){
		

	};
	name(){
		
		
		return this.props.setup.exclusion && this.props.setup.exclusion?.properties?.name ? this.props.setup.exclusion.properties.name : this.makeName();
		
	}
	
	handleNameChange = (e)=>{
		if(this.props.onNameChange)
			this.props.onNameChange(e.target.value);
	}
	handleColorChange = (color)=>{
		
		if(this.props.onColorChange)
			this.props.onColorChange(color);
		
	}
	handleRadiusChange = (radius) =>{
		if(this.props.onRadiusChange)
			this.props.onRadiusChange(radius);
	}
	
	handleRadiusCommit = (radius) =>{
		if(this.props.onRadiusCommit)
			this.props.onRadiusCommit(radius);
	}
	handleClose = (e) => {
		if(this.props.onClose)
			this.props.onClose(e);
	}
	handleDelete = (e) => {
		if(this.props.onDelete)
			this.props.onDelete(e);
	}
	handleOnShow(){
		
	}
	
	handleSaveClose(){
		
		if(this.props.onSaveClose)
			this.props.onSaveClose();
	}
	handleOnClose(){
		
		this.idx = 0;
		
		if(this.props.onClose)
			this.props.onClose();
		this.forceUpdate();
	}
	
	
	componentDidUpdate(prevProps) {
	// Typical usage (don't forget to compare props):
		if (!prevProps.setup.open && this.props.setup.open || (this.props.setup.features && prevProps.setup.features != this.props.setup.features)) {
			this.handleOnShow();
		}
		if (prevProps.setup.open && !this.props.setup.open) {
			this.handleOnClose();
		}
		
	}
	makeName(){
		
		switch(this.props.handler.type){
			case 'polygon':
				return 'Draw exclusion zone';
				break;
			case 'point':
				return 'Set exclusion point';
				break;
		}
		
		return 'Draw ' + this.handler.type;
	}
	
	formatInput = (v) => {
		return parseMeters(v);
	}
	formatOutput = (v) => {
		return formatDistance(v, 1);
	}
	
	render() {
		
		

		
		
		
		
		if(!this.props.setup.open){
			return;
		}
		
		return (
			<div className="powerroads-panel power-roads" >
				<Row>
					<Col xs="12 title pb-2">
						<b>{this.name()}</b>
						<span onClick={(e)=>{this.handleClose(e)}} className="btn btn-close btn-sm float-end"><X size={12} /></span>
					</Col>
					<Col xs="12 my-4">

						<label>Color</label>
						<ColorPicker ref={this.fillHue} onChange={this.handleColorChange} color={this.props.setup.obj.color ?? this.defaultColor} />
					</Col>
					{this.props.handler.type == 'point' && 
					<Col xs="12 my-4">
						<Form.Group as={Col} md="12" controlId="validationFormik03">
							<Form.Label>Radius</Form.Label>
							<EditableRangeFormatable 
								wrpClassName="mb-3" 
								name="radius"  
								min="1" 
								max="5000" 
								step="1" 
								value={this.props.setup.obj.radius ?? this.defaultRadius} 
								onChange={(value)=>{this.handleRadiusChange(value)}} 
								onMouseUp={(value)=>{this.handleRadiusCommit(value)}} 
								inFormatter={this.formatInput}
								outFormatter={this.formatOutput}
							/>

						</Form.Group>
					</Col>
					}
					<Col xs="8">
						<Button variant="primary" onClick={(e)=>{this.handleSaveClose(e)}}>Save & close</Button>
					</Col>
					<Col xs="4 text-end">
						<Button className="ms-auto px-2" variant="outline-primary" onClick={this.handleDelete}><Trash size={16} /></Button>
					</Col>
						
				</Row>
			</div>	
		);
	}
}

export default ExclusionPanel;